module.exports = __webpack_public_path__ + "img/wx-img2.aa117737.png";